import RouteView from '@/layouts/RouteView'

export default {
  path: '/user-mana',
  name: 'User',
  meta: { icon: 'user', title: '用户管理', bread: true },
  component: RouteView,
  children: [
    { path: '/user-mana', redirect: '/user-mana/user-group' },
    {
      path: '/user-mana/user-group',
      name: 'User.UserGroup',
      meta: { title: '用户组管理', bread: true, hasRouteView: true },
      props: true,
      component: () =>
        import(/* webpackChunkName: 'userMana' */ '@/views/user-mana/user-group/index.vue')
    },
    {
      path: '/user-mana/search',
      name: 'User.Search',
      meta: { title: '用户管理', bread: true, hasRouteView: true },
      props: true,
      component: () =>
        import(/* webpackChunkName: 'userMana' */ '@/views/user-mana/search/index.vue')
    },
    {
      path: '/user-mana/user-log',
      name: 'User.UserLog',
      meta: { title: '操作日志', bread: true, hasRouteView: true },
      component: () =>
        import(/* webpackChunkName: 'userMana' */ '@/views/user-mana/user-log/index.vue')
    },
    {
      path: '/user-mana/user-center',
      name: 'User.UserCenter',
      hideInMenu: true,
      meta: { title: '用户中心', bread: true, hasRouteView: true },
      component: () =>
        import(
          /* webpackChunkName: 'userCenterIndex' */ '@/views/user-mana/user-center/index.vue'
        )
    }
  ]
}
